import React, { useState } from 'react'
import moment from 'moment'
import 'moment/locale/es'
import { useForm } from '../../hooks/ useForm'
import { updateNotaQuestion } from '../../helpers/consultas'
import Loading from '../tools/Loading'
moment.locale('es')
const ResponseRowQuestion = ({pregunta,emailDocente,idAsig}) => {
    const [loadingNota, setLoadingNota] = useState(false)
    const {name,email,solveQuestion,date,qualification, id} = pregunta;
    const [value, handleInputChange] = useForm({upNota:qualification})
    const [edit, setEdit] = useState(false)
    const {upNota} = value;

    const handleInputUpQualificacion = () => {
        setLoadingNota(true)
        updateNotaQuestion(emailDocente,idAsig,id,upNota)
        .then(() => {
            setLoadingNota(false)
            setEdit(false)
        })
    }

    return (
        <tr>
            <td>{name}</td>
            <td>{email}</td>
            <td>{solveQuestion}</td>
            <td>{moment(date).fromNow()}</td>
            <td>
                {
                    edit
                    ? <input type='number' name='upNota' 
                        value={upNota} onChange={handleInputChange}
                        placeholder='0.0'
                        min='0.0'
                        max='5.0'    
                        />
                    :upNota
                }
            </td>
            {
                edit
                ?   
                    loadingNota
                    ?<td colSpan='2'><Loading/></td>
                    :
                    <>
                        <td>
                        <button className='btn_success' onClick={handleInputUpQualificacion}>Guardar</button>
                        </td>
                        <td>
                            <button className='btn_danger' onClick={() => setEdit(!edit)}>cancelar</button>
                        </td>
                    </>
                :   <>
                        <td colSpan='2'><button className='btn_info' onClick={() => setEdit(!edit)}>Editar</button></td>
                    </>
            }
            
            
        </tr>
    )
}

export default ResponseRowQuestion
